export const HEADERS = ['Date for', 'Source', 'Market', 'Product', 'Spent'];
